export function createState(container) {
    return {
        // general
        container,

        interaction: false,

        // properties
        _cart: null,
        _previewCart: null,
        _frequency: null,
        _product: null,
        _selling_plan_id: null,
        _total_lashes: null,
        _purchaseType: null,
        _settings: null,
        _productForm: null,
        _productFormMobile: null,
        _currentVariant: null,
        _lashSettings: null,
        _quantity: 1,
        _default_quantity: 1,
        _member_discount: 0,

        initialized: false,
        adding: false,
        settings: {},
        productForm: null,
        productFormMobile: null,
        productFormId: null,
        sliders: {
            optionItemSlider: [],
        },
        originalThumbnails: '',
        originalImages: '',
        lengths: {},

        // new variables
        productSelect: null,
        sellingPlanInput: null,
        wrappedSellingPlanInput: null,
        quantityInput: null,

        // subscription box modal trigger
        monthlyBoxModalTrigger: null,

        dependencies: {},

        isMobile: false,

        activeOption: 1,
    };
}
